/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-18 14:37:48
 * @FilePath: /unifyxp-v2-store-portal/src/components/SmartInput/SmartInput.tsx
 */
import React from 'react';
import css from './SmartInput.less';
import Input from '../Antd/Input/Input';
import Row from '@/src/components/Layouts/Row/Row';
import DeletePopconfirm from '../../components/DeletePopconfirm/DeletePopconfirm';
import { ProductCode } from '../../types/common/product';
import { getI18nFromGeneral } from '@/src/tools/tools';
interface IProps {
  // children;
  // addText: string;
  otherCodeList: ProductCode[];
  confirm;
  onChange?: (e, index) => void;
  maxLength?: number;
  disabled?: boolean;
}

const SmartInput = (props: IProps) => {
  const { otherCodeList = [], confirm, onChange, maxLength, disabled } = props;

  return (
    <React.Fragment>
      {otherCodeList.map((item, index) => (
        <Row
          key={index}
          elements={[
            {
              child: (
                <React.Fragment>
                  <div className={css.title}>{item.title}</div>
                  <div className={css.smartInput}>
                    <Input
                      disabled={disabled}
                      value={item.code}
                      size='large'
                      onChange={(e) => onChange(e, index)}
                      maxLength={maxLength || 50}
                    />
                    <DeletePopconfirm
                      disabled={disabled}
                      title={getI18nFromGeneral(
                        'general.smartInput.delete_confirm',
                      )}
                      confirm={() => confirm(index)}
                      btnClassName={css.smartInputBtn}
                      type='text'
                      size='large'
                    />
                  </div>
                </React.Fragment>
              ),
            },
          ]}
        />
      ))}
    </React.Fragment>
  );
};
export default SmartInput;
